import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { firebaseConfig } from './config.build.js';

// Track Firebase initialization
let firebaseApp = null;
let firestoreDb = null;

// Add debug logging
console.log('Initializing Firebase with config:', {
  apiKey: firebaseConfig.apiKey ? '***' : 'missing',
  projectId: firebaseConfig.projectId,
  hasAppId: !!firebaseConfig.appId
});

try {
  // Only initialize once
  if (!firebaseApp) {
    firebaseApp = initializeApp(firebaseConfig);
    firestoreDb = getFirestore(firebaseApp);
    console.log('🔥 Firebase initialized successfully:', firebaseApp.name);
  } else {
    console.log('🔄 Using existing Firebase instance:', firebaseApp.name);
  }
} catch (error) {
  console.error('Failed to initialize Firebase:', error);
  throw error;
}

export const db = firestoreDb; 